import React from "react";
import { useTranslation } from "react-i18next";
import Currency from "./Currency";
import {
  formatRentalAmount,
  formatRentalDuration,
  getRentalFrequency,
} from "../utils/inStayRental";

// Renders a rental quote (see calculateRentalQuote).
function InStayRentalPriceBreakdown({ quote, currency, className = "" }) {
  const { t } = useTranslation();
  const frequency = getRentalFrequency(quote?.frequency);

  if (!quote || !frequency) return null;

  const money = (value) => (
    <span className="rental-breakdown__amount">
      {currency && <Currency currency={currency} />}
      {formatRentalAmount(value)}
    </span>
  );
  const durationText = formatRentalDuration(t, frequency, quote.duration);

  return (
    <ul className={`check-list v3 rental-breakdown ${className}`.trim()}>
      {frequency.durationBased ? (
        <>
          <li>
            <p>{t("Unit Price")}</p>
            <p>
              {money(quote.unitPrice)}
              <wbr />
              {t(frequency.rateSuffix)}
            </p>
          </li>
          <li>
            <p>{t("Duration")}</p>
            <p>{durationText}</p>
          </li>
          <li>
            <p>
              {t("Rental Subtotal")}
              <span className="rental-breakdown__note">
                {money(quote.unitPrice)} × {durationText}
              </span>
            </p>
            <p>{money(quote.subtotal)}</p>
          </li>
        </>
      ) : (
        <li>
          <p>
            {t("Rental Price")}
            <span className="rental-breakdown__note">
              {t("Per Stay")} · {t("For your entire stay")}
            </span>
          </p>
          <p>{money(quote.subtotal)}</p>
        </li>
      )}
      <li>
        <p>{t("Security Deposit")}</p>
        <p>{money(quote.deposit)}</p>
      </li>
      <li className="rental-breakdown__total">
        <p>{t("Total")}</p>
        <p>{money(quote.total)}</p>
      </li>
    </ul>
  );
}

export default InStayRentalPriceBreakdown;
